import Options from './types/Options';
import UserBrowser from './UserBrowser';

export function initializeBrowserSession(options: Options) {
  UserBrowser.Partner = options.partner;
  UserBrowser.AppName = options.appName;
  UserBrowser.AppVersion = options.version;
  UserBrowser.Stage = process.env.NEXT_PUBLIC_STAGE! === 'prod' ? 'PR' : 'DEV';
}

export * from './buildAnalyticsPayloads';
export * from './trackD2CNonSegmentAnalytics';
export * from './trackD2CSegmentAnalytics';
export * from './types';
export { default as UserBrowser } from './UserBrowser';
export { useUserBrowser } from './useUserBrowser';
